import {Routes} from '@angular/router';
import {analyticsBeforeNavHookGuard} from "./analytics/analytics-before-nav-hook.guard";
import {NavService} from "./services/nav.service";
import {CriticalErrorComponent} from "./critical-error/critical-error.component";
import {redirectLoopProtectionGuard} from "./guards/redirect-loop-protection.guard";
import {referralVisitExitGuard} from "./guards/referral-visit-exit.guard";

export const routes: Routes = [
  {
    path: 'error',
    component: CriticalErrorComponent,
  },
  {
    path: 'finder',
    loadChildren: () => import('./sections/finder-section/finder-section.routes').then(m => m.routes),
    canMatch: [redirectLoopProtectionGuard],
    canActivate: [referralVisitExitGuard],
    // canActivate: [referrerRedirectResolver],
    canDeactivate: [analyticsBeforeNavHookGuard, NavService.waitForBeforeNavHookGuard]
  },
  {
    path: 'booking',
    loadChildren: () => import('./sections/booking-section/booking-section.routes').then(m => m.routes),
    canMatch: [redirectLoopProtectionGuard],
    // canActivate: [referrerRedirectResolver],
    canDeactivate: [analyticsBeforeNavHookGuard, NavService.waitForBeforeNavHookGuard]
  },
  {
    path: '**',
    redirectTo: 'finder',
    pathMatch: 'full'
  }
];
